import { LineEye } from '@qr-front/icons/line-eye'
import { LineEyeOff } from '@qr-front/icons/line-eye-off'
import { LineTrashAlt } from '@qr-front/icons/line-trash-alt'
import { SolidMenu } from '@qr-front/icons/solid-menu'
import { Button } from '@qr-front/ui/components/Button'
import { Tooltip } from '@qr-front/ui/components/Tooltip'
import { isTouchDevice } from '@qr-front/ui/utils'
import { useTranslations } from 'next-intl'
import { useRef } from 'react'

type TActionsProps = {
	category: 'section' | 'product'
	showReorderButton?: boolean
	disabled?: boolean
	onDelete?: () => void
	onHide?: () => void
	onReorder?: () => void
}

export const Actions = ({
	category,
	showReorderButton = false,
	disabled,
	onDelete,
	onHide,
	onReorder,
}: TActionsProps) => {
	const buttonRef = useRef<HTMLButtonElement>(null)
	const t = useTranslations()

	const tooltipTranslation: Record<string, string> = {
		section: t('generator__content_form_section__menu__sections__hide_tooltip'),
		product: t('generator__content_form_section__menu__products__hide_tooltip'),
	}

	const textTranslation: Record<string, string> = {
		section: t('generator__content_form_section__menu__hidden_label'),
		product: t('generator__content_form_section__menu__products__hidden_label'),
	}

	return (
		<div className="flex flex-row items-center justify-end gap-2">
			{disabled && (
				<div className="hidden items-center justify-center gap-2 rounded-full border border-dashed border-border-grey px-4 py-2 tablet:flex">
					<span className="type-body-caption text-dark-grey">
						{textTranslation[category]}
					</span>
				</div>
			)}

			<Button
				ref={buttonRef}
				visual="soft"
				className="h-10 w-10 rounded-full p-0 has-[>svg]:px-0"
				onClick={onHide}
			>
				{disabled ? (
					<LineEyeOff width={16} height={16} />
				) : (
					<LineEye width={16} height={16} />
				)}
			</Button>

			{!isTouchDevice ? (
				<Tooltip anchorRef={buttonRef}>{tooltipTranslation[category]}</Tooltip>
			) : null}

			<Button
				visual="soft"
				className="h-10 w-10 rounded-full p-0 has-[>svg]:px-0"
				onClick={onDelete}
			>
				<LineTrashAlt width={16} height={16} />
			</Button>

			{showReorderButton && (
				<Button
					visual="soft"
					className="h-10 w-10 rounded-full p-0 has-[>svg]:px-0"
					onClick={onReorder}
				>
					<SolidMenu width={16} height={16} />
				</Button>
			)}
		</div>
	)
}
